module.exports = __webpack_public_path__ + "static/img/14000030.65a67a93.png";